<template>
  <el-dialog :title="$t('ExcelConfig.Title')" :visible.sync="dialogVisible" width="500px" :before-close="hide" destroy-on-close append-to-body>
    <el-form ref="timeForm" :model="form" :rules="rules" label-position="top">
      <el-form-item :label="$t('BusinessPurchaseComponentsCom.invoiceNo')" prop="invoiceNumber">
        <BjInput v-model="form.invoiceNumber" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
      </el-form-item>
      <el-form-item :label="$t('billingPage.OrderPostagetime')" prop="invoiceDate">
        <el-date-picker id="getWeekDate1" v-model="weekDataNow1" style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.yearAndWeeks')" @change="changeWeek1">
        </el-date-picker>
        <!-- <el-date-picker v-model="form.invoiceDate" style="width:100%" :picker-options="pickerOptions" type="date" value-format="yyyy-MM-dd" :placeholder="$t('chooseText')" /> -->
      </el-form-item>
      <el-form-item :label="$t('InternalOrderList.company')" prop="logisticsCompany">
        <BjSelectLov v-model="form.logisticsCompany" :option-list="companyList" />
      </el-form-item>
      <el-form-item :label="$t('billingPage.ImportCSV')" prop="fileList">
          <el-upload accept=".csv,.xls,.xlsx" action="" :limit="1" :auto-upload="false" :on-remove="handleRemove" :on-change="importFile">
            <el-button type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
          </el-upload>
      </el-form-item>
      <el-form-item :label="$t('billingPage.OrderPostageImportPDF')" prop="fileTest">
        <UploadFile ref="UploadFileRef" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept=".pdf" :accept-list="['.pdf']" auto-upload limit-hide @handleFileListChange="fileListChange">
          <template slot="default">
            <el-button size="mini" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
          </template>
        </UploadFile>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hide">{{ $t('cancelText') }}</el-button>
      <el-button :disabled="confirmVisible" type="primary" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import { orderApi, settingApi } from '@/api';
  import { getEnvGlobalConfig } from '@/utils';
  import UploadFile from '@/components/Upload/uploadFile';

  export default {
    components: { UploadFile },
    data() {
      return {
        dialogVisible: false,
        file: null,
        exportData: [], // 存放上传的excel文件的数据
        confirmVisible: false,
        form: {
          invoiceNumber: '',
          invoiceDate: '',
          logisticsCompany: '',
          logistics: [],
          csvUrl: '',
          pdfUrl: '',
          week: '',
          sum: '',
        },
        logisticsList: ['AUSP', 'HUNT', 'ALLI', 'COPL', 'CAPT', 'DIFE', 'ARMX'],
        companyList: [
            {label: 'AUSP', value: 'AUSP'},
            {label: 'HUNT', value: 'HUNT'},
            {label: 'ALLI', value: 'ALLI'},
            {label: 'COPL', value: 'COPL'},
            {label: 'DIFE', value: 'DIFE'},
            {label: 'ARMX', value: 'ARMX'},
        ],
        rules: {
          invoiceNumber: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          invoiceDate: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          logisticsCompany: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        },
        weekDataNow1: ''
      };
    },
    methods: {
      changeWeek1(value) {
        this.$nextTick(() => {
          this.form.week = document.querySelector('#getWeekDate1').value;
        });
        if (value) {
          // 将选中的周一日期转换为 Date 对象
          const selectedDate = new Date(value);
          // 计算周日的日期
          // 一周有7天，所以我们需要给选中的日期加上6天来得到周日
          const lastDay = new Date(selectedDate);
          lastDay.setDate(selectedDate.getDate() + 6);
          // 格式化周日的日期为 yyyy-MM-dd
          const formattedLastDay = lastDay.toISOString().split('T')[0];
          // 更新数据属性
          this.form.invoiceDate = formattedLastDay;
        } else {
          this.form.invoiceDate = '';
        }
      },
      show() {
        this.file = null;
        this.dialogVisible = true;
      },
      hide() {
        this.weekDataNow1 = ''
        this.$refs['timeForm'].resetFields();
        this.dialogVisible = false;
      },
      handleRemove() {
        this.form.logistics = [];
      },
      hasEnglishSuffix(str) {
        const suffix = String(str).slice(-3);
        return /[a-zA-Z]/.test(suffix);
      },
      importFile(e) {
        this.uploadFileApi(e.raw).then(res => {
          if (!res.failed) { this.form.csvUrl = 'https://' + res.message; }
        });
        const file = e.raw;
        this.exportData = [];
        this.confirmVisible = false;
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;
          const bytes = new Uint8Array(buffer);
          const length = bytes.byteLength;
          let binary = '';
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          const XLSX = require('xlsx');
          const wb = XLSX.read(binary, {
            type: 'binary',
            cellDates: true
          });
          this.form.logistics = [];
          const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          console.log(111, this.form.invoiceNumber);
          if (this.form.logisticsCompany == 'DIFE') {
            if (outData.map(e => e['INVOICE-NUMBER']).some(e => e != this.form.invoiceNumber)) return this.$message.warning(`${this.$t('BusinessPurchaseComponentsCom.invoiceNo')} ${this.$t('formatErrorText')}`);
            const RATE = outData[outData.length - 2]['CONNOTE-NUMBER'].slice(10);
            // 创建一个对象，用于存储按前缀和后缀分组的累加结果
            const obj = {};
            outData.slice(0, -2).forEach(item => {
              const consignmentNumber = String(item['CONNOTE-NUMBER']).slice(0, 13); // 提取前三位作为前缀
              const suffix = this.hasEnglishSuffix(item['CONNOTE-NUMBER']) ? String(item['CONNOTE-NUMBER']).slice(-3) : 'QQQQ'; // 提取末尾三个英文字符作为后缀，如果不存在则默认为空字符串
              // 如果该前缀在累加器中不存在，则初始化它
              if (!obj[consignmentNumber]) {
                obj[consignmentNumber] = {
                  cSum: 0, // 用于累加c属性
                  dSums: {} // 用于存储按后缀分类的d属性累加结果
                };
              }
              // 初始化或更新该后缀对应的d属性累加器
              if (!obj[consignmentNumber].dSums[suffix]) {
                obj[consignmentNumber].dSums[suffix] = 0;
              }
              // 对该前缀下的c属性和d属性进行累加
              obj[consignmentNumber].cSum += item['TOTAL-CHARGE'];
              obj[consignmentNumber].dSums[suffix] += item['TOTAL-CHARGE'];
            });

            // 提取结果，转换为数组格式（如果需要的话），并只保留两个前缀的结果（假设只有两个不同的前缀）
            const result = [];
            for (const consignmentNumber in obj) {
              const consignmentNumberResult = {
                consignmentNumber,
                cSum: obj[consignmentNumber].cSum,
                dSums: {} // 存储该前缀下各后缀的d属性累加结果
              };
              // 遍历该前缀下的所有后缀及其d属性累加值
              for (const suffix in obj[consignmentNumber].dSums) {
                consignmentNumberResult.dSums[suffix] = obj[consignmentNumber].dSums[suffix];
              }
              result.push(consignmentNumberResult);
            }
            const arr = [];
            result.forEach(item => {
              arr.push({
                consignmentNumber: item.consignmentNumber,
                freightCharge: item.dSums['QQQQ'] || 0, // 运费
                freightChargeGst: (item.cSum * 0.1).toFixed(2),
                preOverweightTotalAmount: Number(item.dSums['WXC'] || 0).toFixed(2), // 税前超重费
                preExtraLongTotalAmount: Number(item.dSums['LXC'] || 0).toFixed(2), // 税前超长费
                preResendTotalAmount: Number(Number(item.cSum) - Number(item.dSums['QQQQ'] || 0) - Number(item.dSums['WXC'] || 0) - Number(item.dSums['LXC'] || 0)).toFixed(2), // 税前退回重发费
                fuelCharge: Number(Number(item.cSum) * RATE / 100).toFixed(2), // 燃油费
                fuelChargeGst: Number(Number(item.cSum) * RATE / 100 * 0.1).toFixed(2),
                preTaxTotalAmount: Number(Number(item.cSum || 0) + Number(item.cSum * RATE / 100)).toFixed(2),
                afterTaxTotalAmount: Number((Number(item.cSum || 0) + Number(item.cSum * RATE / 100))* 1.1).toFixed(2),
              });
            });
            this.form.logistics = arr;
          } else if (this.form.logisticsCompany == 'HUNT') {
            if (outData.map(e => e['InvoiceNumber']).some(e => e != this.form.invoiceNumber)) return this.$message.warning(`${this.$t('BusinessPurchaseComponentsCom.invoiceNo')} ${this.$t('formatErrorText')}`);
            const arr = outData.reduce((acc, item) => {
              const existing = acc.find(obj => obj['consignmentNumber'] === item['ConsignmentNumber']);
              if (existing) {
                existing.freightCharge += Number(item['PriceBaseTotal']);
                existing.fuelCharge += Number(item['PriceLevyTotal']);
                existing.preTaxTotalAmount += (Number(item['PriceGrandTotal']) - Number(item['PriceTaxTotal']));
                existing.afterTaxTotalAmount += Number(item['PriceGrandTotal']);
                existing.preAdditionalTotalAmount += Number(item['PriceAdditionalServiceTotal']);
              } else {
                acc.push({
                  consignmentNumber: item['ConsignmentNumber'],
                  freightCharge: Number(item['PriceBaseTotal']), // 运费
                  fuelCharge: Number(item['PriceLevyTotal']), // 燃油费
                  preTaxTotalAmount: Number(item['PriceGrandTotal']) - Number(item['PriceTaxTotal']), // 燃油税
                  afterTaxTotalAmount: Number(item['PriceGrandTotal']), // 税后总金额
                  preAdditionalTotalAmount: Number(item['PriceAdditionalServiceTotal']), // 税前额外费
                });
              }
              return acc;
            }, []);
            this.form.logistics = arr.filter(jitem => jitem.consignmentNumber).map(item => ({
              consignmentNumber: item.consignmentNumber,
              freightCharge: item.freightCharge.toFixed(2), // 运费
              freightChargeGst: (item.freightCharge * 0.1).toFixed(2), // 运费税
              fuelCharge: item.fuelCharge.toFixed(2), // 燃油费
              fuelChargeGst: (item.fuelCharge * 0.1).toFixed(2), // 燃油税
              preTaxTotalAmount: item.preTaxTotalAmount.toFixed(2), // 税前总金额
              afterTaxTotalAmount: item.afterTaxTotalAmount.toFixed(2), // 税后总金额
              preAdditionalTotalAmount: item.preAdditionalTotalAmount.toFixed(2), // 税前额外费
            }));
          } else if (this.form.logisticsCompany == 'ALLI') {
            if (outData.map(e => e['Invoice Number']).some(e => e != this.form.invoiceNumber)) return this.$message.warning(`${this.$t('BusinessPurchaseComponentsCom.invoiceNo')} ${this.$t('formatErrorText')}`);
            // 过滤出I类再根据Docket No.进行分组，再根据税后燃油费求和计算：K列
            const outFilterData = outData.filter(item => item['Transaction Type'] == 'I');
            if (outFilterData[0]['Year'] == 2024) {
              const ZRYF = outFilterData.filter(item => item['Docket No.'] == 'Fuel Surcharge').reduce((pre, cur) => (pre += cur['Price GST EXC.']), 0); // 总燃油费
              const RYFTOTAL = outFilterData.filter(item => item['Docket No.'] != 'Fuel Surcharge').reduce((pre, cur) => (pre += cur['Price GST EXC.']), 0);
              const RYFL = (ZRYF / RYFTOTAL).toFixed(4);
              const arr = outFilterData.filter(item => item['Docket No.'] != 'Fuel Surcharge').reduce((acc, item) => {
                const existing = acc.find(obj => obj['consignmentNumber'] === item['Docket No.']);
                if (existing) {
                  existing.freightCharge += Number(item['Price GST EXC.']);
                  existing.freightChargeGst += Number(item['GST']);
                  existing.fuelCharge += (Number(item['Price GST EXC.']) * RYFL); // 税后燃油费求和：K列（不需要传入后端）
                  existing.fuelChargeGst += (Number(item['GST']) * RYFL);
                  existing.afterTaxTotalAmount += (Number(item['Price GST EXC.']) + Number(item['GST']) + Number(item['Price GST EXC.']) * RYFL + Number(item['GST']) * RYFL); // 税后总金额
                  existing.invoiceNotesArr.push(String(item['Invoice Notes']));
                } else {
                  acc.push({
                    consignmentNumber: item['Docket No.'],
                    freightCharge: Number(item['Price GST EXC.']), // 运费
                    freightChargeGst: Number(item['GST']), // 运费税
                    fuelCharge: Number(item['Price GST EXC.']) * RYFL,
                    fuelChargeGst: Number(item['GST']) * RYFL,
                    afterTaxTotalAmount: Number(item['Price GST EXC.']) + Number(item['GST']) + Number(item['Price GST EXC.']) * RYFL + Number(item['GST']) * RYFL,
                    invoiceNotesArr: [String(item['Invoice Notes'])]
                  });
                }
                return acc;
              }, []);
              this.form.logistics = arr.filter(jitem => jitem.consignmentNumber).map(item => ({
                consignmentNumber: item.consignmentNumber,
                freightCharge: item.freightCharge.toFixed(2),
                freightChargeGst: item.freightChargeGst.toFixed(2),
                fuelCharge: item.fuelCharge.toFixed(2), // 燃油费
                fuelChargeGst: item.fuelChargeGst.toFixed(2), // 燃油税
                preTaxTotalAmount: (item.afterTaxTotalAmount / 1.1).toFixed(2), // 税前总金额
                afterTaxTotalAmount: item.afterTaxTotalAmount.toFixed(2),
                invoiceNotes: item.invoiceNotesArr.filter(item => item !== '').join(';') // 备注
              }));
            } else {
              const arr = outFilterData.reduce((acc, item) => {
                const existing = acc.find(obj => obj['consignmentNumber'] === item['Docket No.']);
                if (existing) {
                  existing.freightCharge += Number(item['Price GST EXC.']);
                  existing.freightChargeGst += Number(item['GST']);
                  existing['Fuel Levy (GST Inclusive)'] += Number(item['Fuel Levy (GST Inclusive)']); // 税后燃油费求和：K列（不需要传入后端）
                  existing.afterTaxTotalAmount += Number(item['Total Charges']); // 税后总金额
                  existing.invoiceNotesArr.push(String(item['Invoice Notes']) + String(item['Charges Inc. GST']));
                } else {
                  acc.push({
                    consignmentNumber: item['Docket No.'],
                    freightCharge: Number(item['Price GST EXC.']),
                    freightChargeGst: Number(item['GST']),
                    'Fuel Levy (GST Inclusive)': Number(item['Fuel Levy (GST Inclusive)']),
                    afterTaxTotalAmount: Number(item['Total Charges']),
                    invoiceNotesArr: [String(item['Invoice Notes']) + String(item['Charges Inc. GST'])]
                  });
                }
                return acc;
              }, []);
              this.form.logistics = arr.filter(jitem => jitem.consignmentNumber).map(item => ({
                consignmentNumber: item.consignmentNumber,
                freightCharge: item.freightCharge.toFixed(2),
                freightChargeGst: item.freightChargeGst.toFixed(2),
                fuelCharge: (item['Fuel Levy (GST Inclusive)'] / 1.1).toFixed(2), // 燃油费
                fuelChargeGst: (item['Fuel Levy (GST Inclusive)'] / 11).toFixed(2), // 燃油税
                preTaxTotalAmount: (item.afterTaxTotalAmount / 1.1).toFixed(2),
                afterTaxTotalAmount: item.afterTaxTotalAmount.toFixed(2),
                invoiceNotes: item.invoiceNotesArr.filter(item => item !== '').join(';') // 备注
              }));
            }
          } else if (this.form.logisticsCompany == 'AUSP') { // CONSIGNMENT ID
            if (outData.map(e => e['INVOICE NO']).some(e => e != this.form.invoiceNumber)) return this.$message.warning(`${this.$t('BusinessPurchaseComponentsCom.invoiceNo')} ${this.$t('formatErrorText')}`);
            // 根据CONSIGNMENT ID进行数据的累加
            const arr = outData.reduce((acc, item) => {
              const existing = acc.find(obj => obj['consignmentNumber'] == item['CONSIGNMENT ID']);
              if (existing) {
                existing.freightCharge += Number(item['AMOUNT EXCL TAX']);
                existing.freightChargeGst += Number(item['TAX AMOUNT']);
                existing.fuelCharge += Number(item['FUEL SURCHARGE %']);
                existing.fuelChargeGst += Number(item['FUEL GST']);
              } else {
                acc.push({
                  consignmentNumber: item['CONSIGNMENT ID'],
                  freightCharge: Number(item['AMOUNT EXCL TAX']), // 运费
                  freightChargeGst: Number(item['TAX AMOUNT']), // 运费税
                  fuelCharge: Number(item['FUEL SURCHARGE %']), // 燃油费
                  fuelChargeGst: Number(item['FUEL GST']), // 燃油税
                  preTaxTotalAmount: Number(item['TOT AMOUNT EXCL TAX']), // 税前总金额
                  afterTaxTotalAmount: Number(item['AMOUNT INCL TAX']), // 税后总金额
                  preAdditionalTotalAmount: Number(item['OVER MAX LIMITS FEE'] || 0), // 额外费
                  country: item['RECEIVING COUNTRY'],
                  isReturn: String(item['DESCRIPTION']).toLowerCase().indexOf('return') > -1 ? 1 : 0,
                  outerOrderNo: item['CUST REF 1'],
                });
              }
              return acc;
            }, []);
            this.form.sum = (outData.reduce((pre, cur) => (pre += Number(cur['AMOUNT INCL TAX'] || 0)), 0)).toFixed(2)
            console.log(this.form.sum);
            this.form.logistics = arr.filter(jitem => jitem.consignmentNumber).map(item => ({
              consignmentNumber: item.consignmentNumber,
              freightCharge: item.freightCharge.toFixed(2),
              freightChargeGst: item.freightChargeGst.toFixed(2),
              fuelCharge: item.fuelCharge.toFixed(2),
              fuelChargeGst: item.fuelChargeGst.toFixed(2),
              preTaxTotalAmount: (item.freightCharge + item.fuelCharge).toFixed(2),
              afterTaxTotalAmount: (item.freightCharge + item.freightChargeGst + item.fuelCharge + item.fuelChargeGst).toFixed(2),
              country: item.country,
              isReturn: item.isReturn,
              outerOrderNo: item.outerOrderNo,
            }));
          } else if (this.form.logisticsCompany == 'ARMX') {
            if (outData.map(e => e['InvoiceNo']).some(e => e != this.form.invoiceNumber)) return this.$message.warning(`${this.$t('BusinessPurchaseComponentsCom.invoiceNo')} ${this.$t('formatErrorText')}`);
            // 根据ConId先分组,再根据LabelNumber是否为空进行LabelNumber拼接，运费求和
            const obj = outData.reduce((groups, item) => {
              if (!groups[item['ConId']]) {
                groups[item['ConId']] = {
                  aList: [],
                  fuelCharge: 0,
                  freightCharge: 0
                };
              }
              if (!item['LabelNumber']) {
                groups[item['ConId']].fuelCharge = item['LabelCost']; // 燃油费
              } else {
                groups[item['ConId']].freightCharge += item['LabelCost']; // 运费
                groups[item['ConId']].aList.push(item['LabelNumber']);
              }
              return groups;
            }, {});
            this.form.logistics = Object.keys(obj).map(key => {
              const group = obj[key];
              const aCommaSeparated = [...new Set(group.aList)].join(','); // 将非空的a值用逗号拼接
              return {
                consignmentNumber: aCommaSeparated,
                freightCharge: group.freightCharge.toFixed(2), // 运费
                freightChargeGst: (group.freightCharge * 0.1).toFixed(2), // 运费税
                fuelCharge: group.fuelCharge.toFixed(2), // 燃油费
                fuelChargeGst: (group.fuelCharge * 0.1).toFixed(2), // 燃油税
                preTaxTotalAmount: (Number(group.freightCharge) + Number(group.fuelCharge)).toFixed(2),
                afterTaxTotalAmount: (Number(group.freightCharge) + Number(group.freightCharge * 0.1) + Number(group.fuelCharge) + Number(group.fuelCharge * 0.1)).toFixed(2),
              };
            });
          } else if (this.form.logisticsCompany == 'COPL') {
            // const seenIds = new Set();
            const arr = [];
            outData.slice(0, -1).forEach(item => {
              if (item['Inv. No.'] != this.form.invoiceNumber) return this.$message.warning(`${this.$t('BusinessPurchaseComponentsCom.invoiceNo')} ${this.$t('formatErrorText')}`);
              if (item['Ex GST'] && item['Consignment Ref.']) {
                // if (!seenIds.has(item['Consignment Ref.'])) {
                //   seenIds.add(item['Consignment Ref.']);
                  arr.push({
                    consignmentNumber: item['Consignment Ref.'],
                    freightCharge: Number(item['Ex GST']).toFixed(2), // 运费
                    freightChargeGst: Number(item['Ex GST'] * 0.1).toFixed(2), // 运费税
                    fuelCharge: Number(item['Fuel Surcharge']).toFixed(2), // 燃油费
                    fuelChargeGst: Number(item['Fuel Surcharge'] * 0.1).toFixed(2), // 燃油税
                    preTaxTotalAmount: (Number(item['Ex GST']) + Number(item['Fuel Surcharge'])).toFixed(2), // 税前总金额
                    afterTaxTotalAmount: (Number(item['Ex GST']) + Number(item['Fuel Surcharge']) + Number(item['GST'])).toFixed(2)
                  });
                // }
              }
            });
            this.form.logistics = arr;
          }

          const seenIds = new Set();
          outData.forEach(item => {
            switch (this.form.logisticsCompany) {
              case 'CAPT':
                if (item['ItemPrice'] && item['JobNumber']) {
                  if (!seenIds.has(item['JobNumber'])) {
                    seenIds.add(item['JobNumber']);
                    this.form.logistics.push({ freightCharge: Number(item['ItemPrice']).toFixed(2), consignmentNumber: item['JobNumber']});
                  }
                }
                break;
              case 'COPL':
              case 'AUSP':
              case 'HUNT':
              case 'ALLI':
              case 'DIFE':
              case 'ARMX':
                break;
              default: this.$message.warning(this.$t('formatErrorText'));
            }
          });
        };
      },
      fileListChange(file) {
        this.form.pdfUrl = 'https://' + file[0].url;
      },
      async uploadFileApi(file) {
        return await new Promise((resolve, reject) => {
          if (!file) {
            reject(file);
            return;
          }
          const formData = new FormData();
          formData.append('file', file);
          const QUERY = Object.assign({}, {bucketName: getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME')}, {
            fileName: Date.now() + file.name,
          });
          const API_DATA = { BjBody: formData, BjQuery: QUERY };
          settingApi.uploadFiles(API_DATA).then(res => {
            resolve(res);
          });
        });
      },
      confirm() {
        this.$refs.timeForm.validate(valid => {
        if (valid) {
          if (!this.form.csvUrl) return this.$message.warning(this.$t('uploadedCSVFileText'));
          if (this.form.logistics.length && !this.confirmVisible) {
            orderApi.addOrderPostageList(this.form).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                  this.hide();
                  this.$emit('reFresh');
              }, 500);
            }
            });
          } else {
            this.$message.warning(this.$t('formatErrorText'));
          }
        } else {
          return false;
        }
      });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
